import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VenuDetails.css";

const VenueDetails = () => {
  const [venueDetails, setVenueDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVenueDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/venues`
        );
        setVenueDetails(response.data || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching venue details:", error);
        setError("Error loading venue information");
        setLoading(false);
      }
    };

    fetchVenueDetails();
  }, []);

  return (
    <div className="venue-container">
      <div className="venue-header">
        <h1 className="venue-title">Venue Details</h1>
        <p className="venue-subtitle">Conference Location & Facilities</p>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          Loading venue details...
        </div>
      ) : error ? (
        <div className="error-state">{error}</div>
      ) : (
        <div className="venue-content">
          {venueDetails.length > 0 ? (
            venueDetails.map((venue, index) => (
              <div key={index} className="venue-card">
                {venue.imageUrl && (
                  <div className="venue-image-container">
                    <img
                      src={venue.imageUrl}
                      alt={venue.description}
                      className="venue-image"
                    />
                  </div>
                )}
                <p className="venue-description">{venue.description}</p>
              </div>
            ))
          ) : (
            <div className="no-venue">No venue details available</div>
          )}
        </div>
      )}
    </div>
  );
};

export default VenueDetails;